import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { useImageComponentUploadImage } from 'api/mutations/imageComponentUploadImage.mutation';
import { useQueryImageComponentDownloadImage } from 'api/queries/imageComponentDownloadImage.query';

import type { ConfirmWidgetPageWrapperUrlParams } from 'components/pages/ConfirmWidgetPage/ConfirmWidgetPageWrapper';
import {
    IMAGE_UPLOADER_TAB_UPLOAD,
    type ImageUploaderSourceTab,
} from 'components/widgets/ImageUploader/ImageUploader.logic';

type UseImageUploaderProviderProps = {
    widgetId?: number | string | null;
    endpoints: Record<string, string>;
};

export type UseImageUploaderProvider = ReturnType<typeof useImageUploaderProvider>;

export const useImageUploaderProvider = ({ widgetId, endpoints }: UseImageUploaderProviderProps) => {
    const { widgetId: widgetIdFromRoute } = useParams<ConfirmWidgetPageWrapperUrlParams>();
    const [activeSourceTab, setActiveSourceTab] = useState<ImageUploaderSourceTab>(IMAGE_UPLOADER_TAB_UPLOAD);
    const [imageUrl, setImageUrl] = useState<string | null>(null);
    const [imageFile, setImageFile] = useState<File | null>(null);

    const getImagePayload = { widgetId: widgetId ?? widgetIdFromRoute };
    const getImage = useQueryImageComponentDownloadImage(getImagePayload, endpoints.getImage);

    const uploadImagePayload = {
        widgetId: widgetId,
        file: imageFile,
    };
    const uploadImage = useImageComponentUploadImage();

    return {
        ui: {
            state: {
                activeSourceTab,
                imageUrl,
                imageFile,
            },
            setters: {
                setActiveSourceTab,
                setImageUrl,
                setImageFile,
            },
            pills: [],
        },
        api: {
            uploadImage: {
                instance: uploadImage,
                payload: uploadImagePayload,
            },
            getImage: {
                instance: getImage,
                payload: getImagePayload,
            },
        },
    };
};
